import { Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-parent-ai-chat-footer',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './parent-ai-chat-footer.component.html',
  styleUrl: './parent-ai-chat-footer.component.scss',
  host: { class: 'chat-input' },
})
export class ParentAiChatFooterComponent {
  message = input('');
  showSpeechToText = input(false);
  isTranscribing = input(false);
  isRecording = input(false);

  messageChange = output<string>();
  send = output<void>();
  toggleSpeechToText = output<void>();

  onEnterKey(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    if (keyboardEvent.isComposing || keyboardEvent.shiftKey) return;
    keyboardEvent.preventDefault();
    if (!this.message().trim()) return;
    this.send.emit();
  }
}
